import { GalleryImage } from 'common/components';

const CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/new-kitchen';

export const KITCHEN_SIGN_SECTION_GALLERY_LIST: GalleryImage[] = [
  {
    alt: 'Кухня в магазине с элементами дерева',
    src: `new-kitchen/sign-section/modal/1.jpg/1.jpg`,
    srcSmall: `${CDN_PATH}/sign-section/1.jpg/1.jpg`,
    name: 'Кухня в магазине с элементами дерева',
  },
  {
    alt: 'Кухня в магазине в серых тонах',
    src: `new-kitchen/sign-section/modal/2.jpg/2.jpg`,
    srcSmall: `${CDN_PATH}/sign-section/2.jpg/2.jpg`,
    name: 'Кухня в магазине в серых тонах',
  },
  {
    alt: 'Ассортимент кухонь в магазине',
    src: `new-kitchen/sign-section/modal/3.jpg/3.jpg`,
    srcSmall: `${CDN_PATH}/sign-section/3.jpg/3.jpg`,
    name: 'Ассортимент кухонь в магазине',
  },
];
